module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("message"), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('touch', {
    staticClass: "cancel",
    attrs: {
      "tag": "button",
      "type": "button"
    },
    on: {
      "tap": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }), _vm._v(" "), _c('touch', {
    staticClass: "confirm",
    attrs: {
      "tag": "button",
      "type": "button"
    },
    on: {
      "tap": _vm.confirm
    }
  }, [_vm._v("确定")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-acedaddc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Modal.vue
// module id = 211
// module chunks = 1